import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { isMobile } from 'react-device-detect';
import isbot from 'isbot';
import { moBaseURL, rootURL, domainName } from '@utils/common';

const getUserAgent = () => {
  if (!window) return;
  return window.navigator.userAgent;
};

const useViewerHandle = () => {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) return;
    if (!isbot(getUserAgent()) && isMobile) router.replace(moBaseURL + router.asPath);
    if (window.location.origin.replace(/^https?:\/\//, '') === rootURL)
      router.replace('https://' + domainName + router.asPath);
  }, [router]);
};

export default useViewerHandle;
